export default __webpack_public_path__ + "static/media/thalesLogo.5910f0f8.svg";